export const UserIdKey = 'user_id'
export const LoggedInKey = 'logged_in'
export const emailParam = 'email'
export const magicLinkTypeParam = 'linkType'
export const loginErrorParam = 'withError'
